export default "__VITE_ASSET__DDwAbF1c__"